import { render } from "./TicketVue.vue?vue&type=template&id=04ce7dba&scoped=true"
import script from "./TicketVue.vue?vue&type=script&lang=js"
export * from "./TicketVue.vue?vue&type=script&lang=js"

import "./TicketVue.vue?vue&type=style&index=0&id=04ce7dba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ce7dba"]])

export default __exports__